import { Badge, Button, Group, Menu } from "@mantine/core";
import { IconStatusChange, IconTrash } from "@tabler/icons-react";
import type { EnergyRevenuesCellCheckState } from "../../RevenueMonitoring.types";
import { VERIFICATION_OPTIONS } from "./columns/getStatusColumn";

interface EneryRevenuesVerificationTableBatchActionsProps {
  batchIsDisabled: boolean;
  handleChangeStatusBatchVerificationItems: (
    value: EnergyRevenuesCellCheckState["state"]
  ) => void;
  handleDeleteBatchVerificationItems: () => void;
}

function EneryRevenuesVerificationTableBatchActions({
  batchIsDisabled,
  handleChangeStatusBatchVerificationItems,
  handleDeleteBatchVerificationItems
}: EneryRevenuesVerificationTableBatchActionsProps) {
  return (
    <Group>
      <Menu>
        <Menu.Target>
          <Button disabled={batchIsDisabled} leftSection={<IconStatusChange />}>
            Status ändern
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          {VERIFICATION_OPTIONS.map((option) => (
            <Menu.Item
              key={option.value}
              onClick={() =>
                handleChangeStatusBatchVerificationItems(option.value)
              }
            >
              <Badge color={option.color} style={{ cursor: "inherit" }} w={100}>
                {option.label}
              </Badge>
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>
      <Button
        color="error"
        disabled={batchIsDisabled}
        leftSection={<IconTrash />}
        onClick={handleDeleteBatchVerificationItems}
      >
        Löschen
      </Button>
    </Group>
  );
}

export { EneryRevenuesVerificationTableBatchActions };
